'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDotdotdot = require('react-dotdotdot');

var _reactDotdotdot2 = _interopRequireDefault(_reactDotdotdot);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _util = require('../util');

var _constants = require('./constants');

require('./styled-text.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-styled-text';

var StyledText = function (_Component) {
  _inherits(StyledText, _Component);

  function StyledText() {
    _classCallCheck(this, StyledText);

    return _possibleConstructorReturn(this, (StyledText.__proto__ || Object.getPrototypeOf(StyledText)).apply(this, arguments));
  }

  _createClass(StyledText, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          bold = _props.bold,
          children = _props.children,
          className = _props.className,
          numberOfLines = _props.numberOfLines,
          primary = _props.primary,
          secondary = _props.secondary,
          style = _props.style,
          testid = _props.testid,
          type = _props.type;
      var rest = (0, _omit2.default)(this.props, ['onLinkPress', 'onLinkLongPress', 'linkStyle', 'children', 'style', 'numberOfLines', 'testid'].concat(_toConsumableArray(Object.keys(StyledText.propTypes))));

      var useDotDotDot = (0, _util.browserName)() !== _constants.FIREFOX && (0, _util.browserName)() !== _constants.INTERNET_EXPLORER;

      return _react2.default.createElement('div', _extends({
        'data-testid': testid
      }, rest, {
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + '-' + type, true), _defineProperty(_classNames, STYLE_BASE + '-primary', primary), _defineProperty(_classNames, STYLE_BASE + '-secondary', secondary), _defineProperty(_classNames, STYLE_BASE + '-bold', bold), _defineProperty(_classNames, STYLE_BASE + '-truncate', numberOfLines === 1), _defineProperty(_classNames, STYLE_BASE + '-multilineTruncation', numberOfLines > 1 && !useDotDotDot), _defineProperty(_classNames, className, !!className), _classNames)),
        style: style
      }), numberOfLines > 1 && useDotDotDot ? _react2.default.createElement('div', {
        className: STYLE_BASE + '-dotdotdotWrapper'
      }, _react2.default.createElement(_reactDotdotdot2.default, {
        clamp: numberOfLines
      }, children)) : children);
    }
  }]);

  return StyledText;
}(_react.Component);

StyledText.propTypes = {
  bold: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  numberOfLines: _propTypes2.default.number,
  primary: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['h1', 'h2', 'h3', 'base', 'small', 'xSmall'])
};
StyledText.defaultProps = {
  type: 'base',
  primary: true,
  secondary: false,
  bold: false
};
exports.default = StyledText;